function statisticsToGraphData(data, l14days=false, yesterday=false, reverse=false) {
    /**
     * website:
     * name:
     * id:
     * url:
     * 30: date[1,2,3,4,5,6], cpm[1,2,3,4,5,6], impressions[1,2,3,4,5,6], revenue[1,2,3,4,5,6], loop the data get value
     * 14: date[1,2,3,4,5,6], cpm[1,2,3,4,5,6], impressions[1,2,3,4,5,6], revenue[1,2,3,4,5,6], loop the data get value
     * 01: date[1,2,3,4,5,6], cpm[1,2,3,4,5,6], impressions[1,2,3,4,5,6], revenue[1,2,3,4,5,6], loop the data get value
     */
    var last30days = {}

    var date = []
    var cpm = []
    var impressions = []
    var revenue = []
    var viewable_rate = []
    var counter = 0

    data.forEach(function (statistic, key) {
        date.push(statistic.date);
        Object.entries(statistic).forEach(function (stats) {
            if(stats[0] === 'cpm') {
                cpm.push(stats[1]);
            }
            if(stats[0] === 'impressions') {
                impressions.push(stats[1]);
            }
            if(stats[0] === 'revenue') {
                revenue.push(stats[1]);
            }
            if(stats[0] === 'viewable_rate') {
                viewable_rate.push(stats[1]);
            }
        });
        counter++;
    });

    if(reverse) {
        date = date.reverse()
        cpm = cpm.reverse()
        impressions = impressions.reverse()
        revenue = revenue.reverse()
        viewable_rate = viewable_rate.reverse()
    }

    last30days = {
        "date": date,
        "cpm": cpm,
        "impressions": impressions,
        "revenue": revenue
    };

    if(l14days) {
        var last14days = {
            "date": date.slice(17),
            "cpm": cpm.slice(17),
            "impressions": impressions.slice(17),
            "revenue": revenue.slice(17),
        }
        return last14days
    } 
    
    if(yesterday) {
        yesterday = {
            "date": date[date.length -2],
            "cpm": cpm[cpm.length -2],
            "impressions": impressions[impressions.length -2],
            "revenue": revenue[revenue.length -2],
            "viewable_rate": viewable_rate[viewable_rate.length -2],
        }
        return yesterday
    }
    return last30days
}

export default statisticsToGraphData